* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

#configuration-section {
  display: flex;
  flex-direction: column;
  margin-bottom: calc(var(--spacer) * 4);

  #configuration-section-title {
    margin-bottom: calc(var(--spacer) * 2);
  }
}

.steps-section {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 2);
  margin-bottom: calc(var(--spacer) * 4);
}

.inner-steps-section {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer));

  ol {
    list-style: lower-alpha;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 1em;
    font-size: var(--font-size);
  }
}

#run-scan-section {
  padding-bottom: calc(var(--spacer) * 4);
}

#connect-scanner-footer {
  margin-bottom: calc(var(--spacer) * 4);
}

// The following styles are kept similar to other integration components

#details-section {
  max-width: 820px;
  padding-left: var(--spacer);

  .details-header-section {
    display: flex;
    margin-bottom: calc(var(--spacer) * 2);

    .card-logo-container {
      height: 72px;
      width: 72px;
      background: var(--white-layout-201-secondary-on-dark-background);
      border-radius: 50%;
    }

    #integration-description {
      padding-left: 0;
    }
  }
}

.subsection-title {
  padding: var(--spacer) 0;
  color: var(--chart-302-icon-buttons-titles);
  text-transform: uppercase;
}

.custom-space {
  padding-left: calc(var(--spacer) * 3.3);
  margin: var(--spacer) 0;
}
